import { getSessionData } from "../utilfunctions/utilFunctions";

const TREASURY_API = process.env.REACT_APP_TREASURY_API_URL || "/portal/www/Treasury/php/index.php";

function portalUserId() {
  try {
    return JSON.parse(sessionStorage.getItem("user") || "null")?.payload?.body?.User?.id || "";
  } catch {
    return "";
  }
}

export async function treasuryRequest(route, parameters = {}) {
  const session = getSessionData();
  const query = new URLSearchParams({ route, ...parameters });
  const response = await fetch(`${TREASURY_API}?${query}`, {
    credentials: "include",
    cache: "no-store",
    headers: {
      Accept: "application/json",
      "X-App-Id": "400160010",
      "X-Paiy-Auth-User": session.authUser || "",
      "X-Paiy-User-Id": portalUserId(),
      "X-Paiy-Session-Id": session.sessionID || "",
      "X-Paiy-View-Id": session._viewid || "",
      "X-Paiy-Device-Token": session._devicetoken || "",
    },
  });
  const body = await response.text();
  let result;
  try { result = JSON.parse(body); }
  catch { throw new Error(`Treasury returned an invalid response (HTTP ${response.status}).`); }
  if (!response.ok) throw new Error(result.detail || result.error || "Treasury request failed.");
  return result;
}

export const getTreasuryOverview = () => treasuryRequest("overview");
export const getTreasuryForecast = (scenario = "BASE") => treasuryRequest("forecast", { scenario });
export const getTreasuryNostro = () => treasuryRequest("nostro");
export const getTreasuryReconciliation = () => treasuryRequest("reconciliation");
export const getTreasuryPnl = () => treasuryRequest("pnl");
export const getTreasuryLibrary = () => treasuryRequest("library");

// Kept for legacy Treasury components while the new screens replace them.
export const getCurrencyDetails = getTreasuryOverview;
export const getLiquiditySources = getTreasuryOverview;
export const lendingServices = getTreasuryOverview;
